import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetListProfileResponse } from 'domain/models';

interface IUsersState {
  profiles: GetListProfileResponse[];
}

interface IPayloadProfiles extends PayloadAction<GetListProfileResponse[]> {}

const initialState: IUsersState = {
  profiles: [],
};

export const UsersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    loadProfiles: (state, action: IPayloadProfiles) => {
      state.profiles = action.payload;
    },
  },
});

export const { loadProfiles } = UsersSlice.actions;

export default UsersSlice.reducer;
